import { Currency, Locale } from '@synergy/models';
import { getLocalizedString } from '@synergy/utils';

import { ShoppingCartArticle } from '../shopping-cart';
import { ShoppingCartArticleDto } from '../dto/shopping-cart-dto';

export const mapShoppingCartArticle = (
    locales: Locale[],
    currency: Currency,
    article: ShoppingCartArticleDto
): ShoppingCartArticle | null => {
    if (!article) {
        return null;
    }

    const result: ShoppingCartArticle = {
        id: article.id,
        name: getLocalizedString(locales, article.name),
        number: article.number,
        deliveryStatus: article.deliveryStatus,
        stockStatus: article.stockStatus,
        mainPrice: article.prices?.mainPrice ?? 0,
        specialPrice: article.prices?.specialPrices?.[0],
        orderUnit: getLocalizedString(locales, article.orderUnit),
        contentUnit: getLocalizedString(locales, article.contentUnit),
        attributes: article.attributes ?? [],
        globalTradeItemNumber: article.globalTradeItemNumber ?? '',
        contentQuantity: article.contentQuantity,
        minimumOrderQuantity: article.minimumOrderQuantity,
        maximumOrderQuantity: article.maximumOrderQuantity,
        quantityInterval: article.quantityInterval,
        deliveryTimeInDays: article.deliveryTimeInDays,
        isBestPrice: article.isBestPrice ?? false,
        isEcoProduct: article.isEcoProduct ?? false,
        isFavorite: article.isFavorite ?? false, // TODO: remove optionality after backend implementation -> Can we remove this?
        currency,
    };

    return result;
};
